import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  Button,
  CustomInput,
  Description,
  SubTitle,
} from "../../Components/CustomComponents";
import AccountLayout from "../../Components/Layouts/AccountLayout";
import { WEB_ROUTES } from "../../constants";
import { storeToken } from "../../Data/services/localStorageService";
import { ACCOUNT_ENUM } from "./Route";
import Toast from "../../Hooks/useToast";
import LoadingButton from "../../Components/CustomComponents/LoadingButton";
import { useLoginUserMutation } from "../../Data/services/userAuthApi copy";

export default function Login({ setPage }) {
  const { handleSubmit, control, register } = useForm();
  const navigate = useNavigate();
  const [LoginAPI, { data, isSuccess, isLoading }] = useLoginUserMutation();

  // const pagename = useSelector((state) => state.pagename.pagename);

  const handleForgotPasswordClick = () => {
    setPage(ACCOUNT_ENUM.FORGOT_PASSWORD);
  };

  const handleLogin = async (data) => {
    let payload = {
      device_type: "234",
      device_token: "web",
      email: data?.email,
      password: data?.password,
      role: "admin",
    };

    // storeToken("There was a problem");
    // navigate(WEB_ROUTES.DASHBOARD);

    // return;

    // console.log(data, "There was a problem");

    if (!data?.email) {
      return;
    }
    try {
      const response = await LoginAPI(payload).unwrap();
      // SetAuthUserLocalStorage(response?.data?.data)
      // SetTokenLocalStorage(response?.data?.data?.api_token)
      console.log(response?.data?.api_token);

      storeToken(response?.data?.api_token);
      navigate(WEB_ROUTES.DASHBOARD);
      Toast(response?.message, "success");
    } catch (error) {
      console.log(error, "error here");
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };
  return (
    <AccountLayout>
      {
        // <Title text="Welcome to" classes="mb-2 fs-4" />
      }
      <SubTitle text="Admin Panel" classes="mb-2" />

      <Form onSubmit={handleSubmit(handleLogin)}>
        <Controller
          control={control}
          name="email"
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <InputGroup
              className="mb-3"
              style={{
                width: "300px",
              }}
            >
              <CustomInput
                placeholder="Email"
                type="email"
                onChange={onChange}
              />
            </InputGroup>
          )}
        />
        <Controller
          control={control}
          name="password"
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <InputGroup
              className="mb-3"
              style={{
                width: "300px",
              }}
            >
              <CustomInput
                type="password"
                placeholder="Password"
                onChange={onChange}
              />
            </InputGroup>
          )}
        />
        <Button
          text={<>{isLoading ? <LoadingButton /> : "Login"}</>}
          classes="mt-3 mb-2"
          type="submit"
          onClick={handleLogin}
        />
      </Form>
      <Description
        classes="ms-auto cursor-pointer"
        text="Forgot Password ?"
        onClick={handleForgotPasswordClick}
      />
    </AccountLayout>
  );
}
